import { render } from "./calendar-type.vue?vue&type=template&id=6dbf4e55&lang=pug"
import script from "./calendar-type.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar-type.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__